var notification = require('notification'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    userServices = require('userProfileService'),
    wordCount = require('wordCount');

var editProfilePublic = (function() {

    var formValidation = function() {
        $('#public-profile-form').validate({
            rules: {
                first_name: {
                    required: true
                },
                last_name: {
                    required: true
                },
                bio: {
                    maxlength: 1500
                }
            },
            submitHandler: function() {
                $('window').btnLoader($('#update-profile-public'));
                new getFormValues();
            }
        });
    };

    var getFormValues = function() {
        var item = new Object();

        item.first_name = $('#first_name').val();
        item.last_name = $('#last_name').val();
        item.bio = $('#bio').val();
        item.country = $('#country').val();
        item.website = $('#website').val();
        item.twitter = $('#twitter_url').val();
        item.facebook_url = $('#facebook_url').val();
        item.instagram_url = $('#instagram_url').val();

        var data = JSON.stringify(item);

        userProfilePublicService(data, userProfilePublicResponse, userProfilePublicerrorResponse);

    };

    var userProfilePublicResponse = function(dataResponse) {
        if (dataResponse.statusCode === 200) {
            $('window').notification({title: 'Your profile has been successfully updated.'});
        } else {
            $('window').notification({
                title: 'There was an error updating your profile. Error: ' + dataResponse.message,
                error: true
            });
        }

    };

    var userProfilePublicerrorResponse = function() {
        $('window').notification({title: 'There was an error updating your profile. Please try again or <a href="mailto:help@thecoachingmanual.com?subject=Cannot update my user profile">contact us if the problem persists</a>.', error: true});
    };

    var init = function() {
        formValidation();
        var elem = $("#counter");
        $("#bio").limiter(3000, elem);
    };
    return {init: init};
})();


if ($('.profile-nav').length) {
    editProfilePublic.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/profile/edit-profile-public.js